import { combineReducers } from "redux";
// import axios from "axios";
import { API } from "../../../../../const";
import _ from 'lodash';
import { unAuthorized } from '../../../../auth/Auth.ducks'
import { Service } from "../../../../service/service"
import { fetchKids } from "../../../kids-list/Kids-list.ducks";


// Arrivée actions

// export const UPDATE_IDENTITE_PENDING = "UPDATE_IDENTITE_PENDING";
// export const UPDATE_IDENTITE_REJECTED = "UPDATE_IDENTITE_REJECTED";
// export const UPDATE_IDENTITE_FULFILLED = "UPDATE_IDENTITE_FULFILLED";
export const UPDATE_IDENTITE_INFO_ENFANT_PENDING = "UPDATE_IDENTITE_INFO_ENFANT_PENDING";
export const UPDATE_IDENTITE_INFO_ENFANT_REJECTED = "UPDATE_IDENTITE_INFO_ENFANT_REJECTED";
export const UPDATE_IDENTITE_INFO_ENFANT_FULFILLED = "UPDATE_IDENTITE_INFO_ENFANT_FULFILLED";

export const UPDATE_IDENTITE_INFO_PARENT_PENDING = "UPDATE_IDENTITE_INFO_PARENT_PENDING";
export const DELETE_IDENTITE_INFO_PARENT_PENDING = "DELETE_IDENTITE_INFO_PARENT_PENDING";
export const UPDATE_IDENTITE_INFO_PARENT_REJECTED = "UPDATE_IDENTITE_INFO_PARENT_REJECTED";
export const DELETE_IDENTITE_INFO_PARENT_REJECTED = "DELETE_IDENTITE_INFO_PARENT_REJECTED";
export const UPDATE_IDENTITE_INFO_PARENT_FULFILLED = "UPDATE_IDENTITE_INFO_PARENT_FULFILLED";
export const DELETE_IDENTITE_INFO_PARENT_FULFILLED = "DELETE_IDENTITE_INFO_PARENT_FULFILLED";

export const UPDATE_IDENTITE_INFO_TIERCE_PENDING = "UPDATE_IDENTITE_INFO_TIERCE_PENDING";
export const UPDATE_IDENTITE_INFO_TIERCE_REJECTED = "UPDATE_IDENTITE_INFO_TIERCE_REJECTED";
export const UPDATE_IDENTITE_INFO_TIERCE_FULFILLED = "UPDATE_IDENTITE_INFO_TIERCE_FULFILLED";

export const ARCHIVE_ENFANT_PENDING = "ARCHIVE_ENFANT_PENDING";
export const ARCHIVE_ENFANT_REJECTED = "ARCHIVE_ENFANT_REJECTED";
export const ARCHIVE_ENFANT_FULFILLED = "ARCHIVE_ENFANT_FULFILLED";

export const RECUPERER_ENFANT_PENDING = "RECUPERER_ENFANT_PENDING";
export const RECUPERER_ENFANT_REJECTED = "RECUPERER_ENFANT_REJECTED";
export const RECUPERER_ENFANT_FULFILLED = "RECUPERER_ENFANT_FULFILLED";

export const DELETE_ENFANT_PENDING = "DELETE_ENFANT_PENDING";
export const DELETE_ENFANT_REJECTED = "DELETE_ENFANT_REJECTED";
export const DELETE_ENFANT_FULFILLED = "DELETE_ENFANT_FULFILLED";

export const UPDATE_COUPLAGE_PENDING = "UPDATE_COUPLAGE_PENDING";
export const UPDATE_COUPLAGE_REJECTED = "UPDATE_COUPLAGE_REJECTED";
export const UPDATE_COUPLAGE_FULFILLED = "UPDATE_COUPLAGE_FULFILLED";

export const UPDATE_PHOTO_ENFANT_PENDING = "UPDATE_PHOTO_ENFANT_PENDING";
export const UPDATE_PHOTO_ENFANT_REJECTED = "UPDATE_PHOTO_ENFANT_REJECTED";
export const UPDATE_PHOTO_ENFANT_FULFILLED = "UPDATE_PHOTO_ENFANT_FULFILLED";

export const UPLOAD_PENDING = "UPLOAD_PENDING";
export const UPLOAD_REJECTED = "UPLOAD_REJECTED";
export const UPLOAD_FULFILLED = "UPLOAD_FULFILLED";



const loading = (state = {}, { type }) => {
  switch (type) {
    case UPDATE_IDENTITE_INFO_ENFANT_PENDING:
    case UPDATE_IDENTITE_INFO_PARENT_PENDING:
    case DELETE_IDENTITE_INFO_PARENT_PENDING:
    case UPDATE_PHOTO_ENFANT_PENDING:
    case UPDATE_IDENTITE_INFO_TIERCE_PENDING:
    case ARCHIVE_ENFANT_PENDING:
    case DELETE_ENFANT_PENDING:
    case UPLOAD_PENDING:
      return true;
    case UPDATE_IDENTITE_INFO_ENFANT_REJECTED:
    case UPDATE_IDENTITE_INFO_ENFANT_FULFILLED:
    case UPDATE_IDENTITE_INFO_PARENT_REJECTED:
    case DELETE_IDENTITE_INFO_PARENT_REJECTED:  
    case UPDATE_IDENTITE_INFO_PARENT_FULFILLED:
    case DELETE_IDENTITE_INFO_PARENT_FULFILLED:
    case UPDATE_IDENTITE_INFO_TIERCE_REJECTED:
    case UPDATE_IDENTITE_INFO_TIERCE_FULFILLED:
    case UPDATE_PHOTO_ENFANT_REJECTED:
    case UPDATE_PHOTO_ENFANT_FULFILLED:
    case ARCHIVE_ENFANT_REJECTED:
    case ARCHIVE_ENFANT_FULFILLED:
    case DELETE_ENFANT_REJECTED:
    case DELETE_ENFANT_FULFILLED:
    case UPLOAD_FULFILLED:
      return false;
    default:
      return false;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case UPDATE_IDENTITE_INFO_ENFANT_PENDING:
    case UPDATE_IDENTITE_INFO_ENFANT_FULFILLED:
    case UPDATE_IDENTITE_INFO_PARENT_PENDING:
    case UPDATE_IDENTITE_INFO_PARENT_FULFILLED:
    case DELETE_IDENTITE_INFO_PARENT_PENDING: 
    case DELETE_IDENTITE_INFO_PARENT_FULFILLED:  
    case UPDATE_IDENTITE_INFO_TIERCE_PENDING:
    case UPDATE_IDENTITE_INFO_TIERCE_FULFILLED:
    case UPDATE_PHOTO_ENFANT_PENDING:
    case UPDATE_PHOTO_ENFANT_FULFILLED:
    case ARCHIVE_ENFANT_PENDING:
    case ARCHIVE_ENFANT_REJECTED:
    case DELETE_ENFANT_PENDING:
    case DELETE_ENFANT_REJECTED:
    case UPLOAD_PENDING:
    case UPLOAD_REJECTED:



      return null;
    case UPDATE_IDENTITE_INFO_ENFANT_REJECTED:
    case UPDATE_IDENTITE_INFO_PARENT_REJECTED:
    case DELETE_IDENTITE_INFO_PARENT_REJECTED:
    case UPDATE_IDENTITE_INFO_TIERCE_REJECTED:
    case UPDATE_PHOTO_ENFANT_REJECTED:
    case ARCHIVE_ENFANT_FULFILLED:
    case DELETE_ENFANT_FULFILLED:
    case UPLOAD_FULFILLED:

      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case UPDATE_IDENTITE_INFO_ENFANT_FULFILLED:
    case UPDATE_IDENTITE_INFO_PARENT_FULFILLED:
    case DELETE_IDENTITE_INFO_PARENT_FULFILLED: 
    case UPDATE_IDENTITE_INFO_TIERCE_FULFILLED:
    case UPDATE_PHOTO_ENFANT_FULFILLED:
    case ARCHIVE_ENFANT_FULFILLED:
    case DELETE_ENFANT_FULFILLED:
    case UPLOAD_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;

    default:
      return state;
  }
};
const isArchived = (state = false, { type, payload }) => {
  switch (type) {
    case ARCHIVE_ENFANT_FULFILLED:
    case RECUPERER_ENFANT_FULFILLED:
    case DELETE_ENFANT_FULFILLED:
      return true

    default:
      return false;
  }
};

// identite reducer
export default combineReducers({ loading, error, data ,isArchived});

// export const updateIdentiteSimple = (tok,id,data) => {
//   return (dispatch) => {
//     const response = Service.put(`${API}api/enfant/creche/enfants/${id}`,data, { headers: { Authorization: `Bearer ${tok}` } })
//     response.then((res) => {
//       dispatch({ type: UPDATE_IDENTITE_FULFILLED, payload: res })
//     })
//     response.catch(err => {
//       dispatch({ type: UPDATE_IDENTITE_REJECTED, payload: err })
//       if (err && err.response && err.response.status === 401) {
//         dispatch(unAuthorized())
//       }
//     })
//   }
// }

export const updateIdentiteSimpleInfoEnfant = (tok, id, data) => {
  return (dispatch) => {
    const response = Service.put(`${API}api/enfant/creche/enfants/${id}`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: UPDATE_IDENTITE_INFO_ENFANT_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: UPDATE_IDENTITE_INFO_ENFANT_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
      }
    })
  }
}
export const updateIdentiteSimpleInfoParent = (tok, id, data) => {
  return (dispatch) => {
    const response = Service.put(`${API}api/enfant/creche/enfants/${id}/parents`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: UPDATE_IDENTITE_INFO_PARENT_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: UPDATE_IDENTITE_INFO_PARENT_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
export const deleteIdentiteSimpleInfoParent = (tok, id, data) => {
  return (dispatch) => {
    const response = Service.put(`${API}api/enfant/creche/enfants/${id}/parents`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: DELETE_IDENTITE_INFO_PARENT_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: DELETE_IDENTITE_INFO_PARENT_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
export const updateIdentiteSimpleInfoTierce = (tok, id, data) => {
  return (dispatch) => {
    const response = Service.put(`${API}api/enfant/creche/enfants/${id}/tierces-autorises`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: UPDATE_IDENTITE_INFO_TIERCE_FULFILLED, payload: res })
      dispatch(fetchKids(tok))
    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: UPDATE_IDENTITE_INFO_TIERCE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
export const archiveEnfant = (tok, id) => {
  return (dispatch) => {
    const response = Service.post(`${API}api/enfant/creche/enfants/${id}/archives`, {}, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: ARCHIVE_ENFANT_FULFILLED, payload: res })
      dispatch(fetchKids(tok))

    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: ARCHIVE_ENFANT_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
export const recupererEnfant = (tok, id) => {
  return (dispatch) => {
    const response = Service.deleteOne(`${API}api/enfant/creche/enfants/${id}/archives`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: RECUPERER_ENFANT_FULFILLED, payload: res })
      dispatch({ type: "OPEN_SNACKBAR_SUCCESS"})
      dispatch(fetchKids(tok))

    })
    response.catch(err => {
      dispatch({ type: RECUPERER_ENFANT_REJECTED, payload: err })
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: err.response.message })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const deleteEnfant = (tok, id) => {
  return (dispatch) => {
    const response = Service.deleteOne(`${API}api/enfant/creche/enfants/${id}`, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: DELETE_ENFANT_FULFILLED, payload: res })
      dispatch(fetchKids(tok))

    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: DELETE_ENFANT_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
export const updateCouplage = (tok, id, data) => {
  return (dispatch) => {
    const response = Service.put(`${API}api/enfant/creche/enfants/${id}/parents/couplages`, data, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: UPDATE_COUPLAGE_FULFILLED, payload: res })
      dispatch(fetchKids(tok))

    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: UPDATE_COUPLAGE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}

export const updatePhotoEnfant = (tok, id, idPhoto) => {
  return (dispatch) => {
    const response = Service.put(`${API}api/enfant/creche/enfants/${id}/photo`, {idPhoto: idPhoto}, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: UPDATE_PHOTO_ENFANT_FULFILLED, payload: res })
      dispatch(fetchKids(tok))

    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: UPDATE_PHOTO_ENFANT_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}




